import {ForkEffect, spawn} from 'redux-saga/effects';
import loadLightProjectsSaga, {
  requestLoadLightProjects,
} from 'App/features/searchEntities/lightProjects/sagas/loadLightProjectsSaga';
import updateLightProjectSaga, {
  requestUpdateLightProject,
} from 'App/features/searchEntities/lightProjects/sagas/updateLightProjectSaga';
import deleteLightProjectSaga, {
  requestDeleteLightProject,
} from 'App/features/searchEntities/lightProjects/sagas/deleteLigthProjectSaga';
import loadFullProjectsSaga, {
  requestLoadFullProjects,
} from 'App/features/searchEntities/lightProjects/sagas/loadFullProjectsSaga';
import createProjectSaga, {
  requestCreateProject,
} from 'App/features/searchEntities/lightProjects/sagas/createProjectSaga';

function* lightProjectsSaga(): Generator<ForkEffect<void>, void, unknown> {
  yield spawn(loadLightProjectsSaga);
  yield spawn(updateLightProjectSaga);
  yield spawn(deleteLightProjectSaga);
  yield spawn(loadFullProjectsSaga);
  yield spawn(createProjectSaga);
}

export {
  requestLoadLightProjects,
  requestUpdateLightProject,
  requestDeleteLightProject,
  requestLoadFullProjects,
  requestCreateProject,
};

export default lightProjectsSaga;
